import {
  LoadingContainer,
  LegacyPage,
  Modal,
  Model,
  Panels,
  Bar,
  Form,
  NumericInput,
} from 'peach/components'
import { useParams } from 'peach/router'
import { LoanStatusSelect } from 'peach/scopes/loan'

import { useInternalLoanDrawsGet, useInternalLoanDrawsPost } from 'core/types'

import { defaultDraw } from './defaultDraw'

const LoanDraws = () => {
  const { companyId, personId, loanId } = useParams<{
    companyId?: string
    personId?: string
    loanId?: string
  }>()

  const {
    data: draws,
    isLoading: isLoadingDraws,
    error: drawsError,
  } = useInternalLoanDrawsGet({
    companyId,
    personId,
    loanId,
    options: { enabled: !!personId && !!loanId },
  })

  const { mutateAsync: createLoanDraw, isPending: isPendingCreateLoanDraw } =
    useInternalLoanDrawsPost({
      companyId,
      personId,
      loanId,
    })

  const sendCreateLoanDraws = async (formData) => {
    try {
      await createLoanDraw(formData)
    } catch (err) {
      console.error('Error creating loan draw:', err)
    }
  }

  return (
    <Panels header={<Bar title='Draws' />}>
      <Modal
        initialValue={defaultDraw}
        onSubmit={sendCreateLoanDraws}
        title='Create Loan Draw'
      >
        <LoanStatusSelect formKey='status' />
        <Form.Provider formKey='atOrigination'>
          <Form.List add formKey='interestRates' remove>
            <Form.Row>
              <NumericInput formKey='days' />
              <NumericInput formKey='rate' />
            </Form.Row>
          </Form.List>
        </Form.Provider>
      </Modal>
      <LoadingContainer
        error={drawsError}
        isLoading={isLoadingDraws || isPendingCreateLoanDraw}
      >
        <LegacyPage.Full>
          <Model.List json={draws} />
        </LegacyPage.Full>
      </LoadingContainer>
    </Panels>
  )
}

export default LoanDraws
